import type { ApiRequest } from '@/types/api';
import type { Notification, NotificationType } from '@/types/models';
import type { PaginationLinks, PaginationMeta } from '@foodics/ui-common';

export type ListNotificationsRequest = ApiRequest<
    'GET',
    'notifications',
    {
        data: Notification[];
        links: PaginationLinks;
        meta: PaginationMeta;
    }
>;

export type NotificationDetailsRequest = ApiRequest<
    'GET',
    `notifications/${string}`,
    { data: Notification }
>;

export type MarkAsReadNotificationRequest = ApiRequest<
    'POST',
    `notifications/${string}/mark-as-read`,
    { data: { message: string } },
    never //payload is empty
>;

export type CountByTypeNotificationsRequest = ApiRequest<
    'GET',
    `notifications/count`,
    Record<NotificationType, number>
>;

export type MarkAllAsReadNotificationRequest = ApiRequest<
    'POST',
    `notifications/mark-all-as-read`,
    { data: { message: string } },
    {
        types?: NotificationType[];
    }
>;

type NotificationsApi = {
    list: ListNotificationsRequest['url'];
    details: (id: string) => NotificationDetailsRequest['url'];
    markAsRead: (id: string) => MarkAsReadNotificationRequest['url'];
    countByType: CountByTypeNotificationsRequest['url'];
    markAllAsRead: MarkAllAsReadNotificationRequest['url'];
};

export const notificationsApi: NotificationsApi = {
    list: 'notifications',
    details: (id: string) => `notifications/${id}`,
    markAsRead: (id: string) => `notifications/${id}/mark-as-read`,
    countByType: 'notifications/count',
    markAllAsRead: 'notifications/mark-all-as-read',
};
